import type { Command } from 'commander';
import { getAppName } from '@gitlab-org/tui';

/** Joins each node's `.name()` from the root down to `cmd`, e.g. `duo plugin marketplace`. */
function commandPath(cmd: Command): string {
  const parts: string[] = [];
  for (let node: Command | null = cmd; node; node = node.parent) {
    parts.unshift(node.name());
  }
  return parts.join(' ');
}

/**
 * One-line `--help` pointer. Pass the erroring node to scope it; omit for the
 * top-level case.
 *
 * Worded as "for usage" (not "for a list of commands") because this hint is
 * appended after *any* native commander error (see `showHelpAfterError`) —
 * including on leaf commands like `duo version --bogus`, where `--help`
 * shows usage/options rather than a command list.
 */
export const helpHint = (cmd?: Command): string =>
  `(Run ${cmd ? commandPath(cmd) : getAppName()} --help for usage.)`;
